import React from "react";
import Rollbar from '../../utils/RollbarTracking'
import axios from 'axios'
import { toast } from 'react-toastify';
import Modal from 'react-responsive-modal';
import moment from 'moment'

import {SettingsNav} from '../../components/SettingsNav'

export class SettingsHolidays extends React.Component {

  constructor(props)  {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    settings: {holidays:[]},
    date: '',
    modalOpen: false
  }

  componentWillMount() {
    this.fetchSupplierData();
  }

  handleChange (evt) {
    this.setState({ [evt.target.name]: evt.target.value });
  }

  fetchSupplierData = async () => {
    axios.get('/user')
        .then(data => {
          var settings = JSON.parse(data[0].settings)
          this.setState({
            settings: settings
          });
        })
        .catch (err => {
          console.error(err)
          Rollbar.error(err)
          toast.error('Failed to fetch user data')
        })
  }

  updateSettings = async (newSettings) => {
    let requestParams = {
      'settings': newSettings
    }
    axios.post('/user/update/settings', requestParams)
        .then(data => {
          this.fetchSupplierData()
        })
        .catch (err => {
          console.error(err); 
          Rollbar.error(err)
          toast.error("Error: Could not save settings!");
        })
  }

  deleteHoliday = async (index) => {
    var settings = this.state.settings
    settings.holidays.splice(index, 1)
    this.updateSettings(settings)
  }

  addHoliday = async () => {
    var settings = this.state.settings
    settings.holidays.push(this.state.date)
    this.updateSettings(settings)
    this.closeModal()
  }

  openModal = () => {
		this.setState({ modalOpen: true });
	};

	closeModal = () => {
		this.setState({ modalOpen: false });
	};

    render() {
        return (
            <div className="mar-bot-lg">
              <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1 mb-3 border-bottom">
                <h1 className="h3">Settings</h1>
              </div>
              <div className="row">
                <div className="col-md-2 col-sm-12">
                  <SettingsNav/>
                </div>
                <div className="col-md-10 col-sm-12">
                  <div className="card">
                    <div className="card-header">
                      Holidays
                    </div>
                    <div className="card-body">
                      {this.state.settings.holidays.map((data, index) =>
                        <div className="card bg-light mb-3" key={index}>
                          <div className="card-body p-3">
                            <div className="row">
                              <div className="col-6 my-auto">
                              <h6 className="m-0">{moment(data, 'YYYY-MM-DD').format('DD-MM-YY - dddd')}</h6>
                              </div>
                              <div className="col-6 text-right">
                                <button type="button" onClick={() => this.deleteHoliday(index)} className="btn btn-danger btn-sm">Delete</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div className="text-center">
                        <button type="button" className="btn btn-success btn-sm pl-3 pr-3" onClick={this.openModal}>Add Holiday Date</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Modal open={this.state.modalOpen} onClose={this.closeModal} center showCloseIcon={false} classNames={{ modal: 'modal' }}>
                <div className="modal-dialog">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Add Holiday Date</h5>
                      <button type="button" className="close" onClick={this.closeModal}>
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      <div className="form-group">
                        <label>Date:</label>
                        <input type="date" className="form-control" name="date" value={this.state.date} onChange={this.handleChange} />
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button type="button" className="btn btn-secondary" onClick={this.closeModal}>Close</button>
                      <button type="button" onClick={this.addHoliday} className="btn btn-primary" disabled={!this.state.date}>Save changes</button>
                    </div>
                  </div>
                </div>
              </Modal>
            </div>
        );
    }
}
